import { render } from "./edit-unit.vue?vue&type=template&id=70d18ac5&scoped=true&ts=true"
import script from "./edit-unit.vue?vue&type=script&lang=tsx"
export * from "./edit-unit.vue?vue&type=script&lang=tsx"

import "./edit-unit.vue?vue&type=style&index=0&id=70d18ac5&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d18ac5"]])

export default __exports__